import axios from "axios";

const API_BASE_URL =
  import.meta.env.VITE_API_URL || "http://localhost:8080/api";

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Import all services
export { default as authService } from "./authService";
export { default as companyService } from "./companyService";
export { default as userService } from "./userService";
export { default as roleService } from "./roleService";
export { default as customerService } from "./customerService";
export { default as orderService } from "./orderService";
export { default as productService } from "./productService";
export { default as stockService } from "./stockService";
export { default as paymentService } from "./paymentService";
export { default as employeeService } from "./employeeService";
export { default as measurementService } from "./measurementService";
export { default as stockTransactionService } from "./stockTransactionService";
export { default as expenseService } from "./expenseService";
export { default as accountService } from "./accountService";
export { default as bankDetailService } from "./bankDetailService";
export { default as invoiceService } from "./invoiceService";

// Legacy API exports for backward compatibility
// Note: authAPI removed to avoid circular dependency
// Use authService directly instead

export default api;
